// Page de login SolidStart utilisant le formulaire HTML natif (compat
// Safari iOS ITP) qui POST sur /api/auth/sign-in/email via BetterAuth.

import { createSignal, Show } from "solid-js";
import { useNavigate, useSearchParams } from "@solidjs/router";

export default function LoginPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [error, setError] = createSignal<string | null>(typeof params.err === "string" ? params.err : null);
  const [busy, setBusy] = createSignal(false);

  async function submit(e: SubmitEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await fetch("/api/auth/sign-in/email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email: email(), password: password() }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok || data.error) {
        setError(data.error?.message || data.error || "invalid_credentials");
        return;
      }
      navigate("/console/session", { replace: true });
    } catch (e: unknown) {
      setError(`Erreur réseau: ${e instanceof Error ? e.message : "inconnue"}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
        "min-height": "100vh",
        background: "#0f172a",
        color: "#e2e8f0",
        "font-family": "system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: "#1e293b",
          border: "1px solid #334155",
          "border-radius": "8px",
          padding: "2rem",
          width: "min(360px, calc(100vw - 32px))",
        }}
      >
        <h1 style={{ "font-size": "1.25rem", "font-weight": 600, "margin-bottom": "1.5rem", "text-align": "center" }}>
          RemoteWS
        </h1>
        <form onSubmit={submit}>
          <label style={{ display: "block", "font-size": ".875rem", color: "#94a3b8", "margin-bottom": ".25rem" }}>
            Email
            <input
              type="email"
              autocomplete="username"
              required
              value={email()}
              onInput={(e) => setEmail(e.currentTarget.value)}
              style={{
                display: "block",
                width: "100%",
                padding: ".5rem .75rem",
                background: "#0f172a",
                border: "1px solid #334155",
                "border-radius": "6px",
                color: "#e2e8f0",
                "font-size": ".875rem",
                "margin-bottom": "1rem",
              }}
            />
          </label>
          <label style={{ display: "block", "font-size": ".875rem", color: "#94a3b8", "margin-bottom": ".25rem" }}>
            Mot de passe
            <input
              type="password"
              autocomplete="current-password"
              required
              value={password()}
              onInput={(e) => setPassword(e.currentTarget.value)}
              style={{
                display: "block",
                width: "100%",
                padding: ".5rem .75rem",
                background: "#0f172a",
                border: "1px solid #334155",
                "border-radius": "6px",
                color: "#e2e8f0",
                "font-size": ".875rem",
                "margin-bottom": "1rem",
              }}
            />
          </label>
          <button
            type="submit"
            disabled={busy()}
            style={{
              width: "100%",
              padding: ".6rem",
              background: busy() ? "#475569" : "#3b82f6",
              color: "#fff",
              border: "none",
              "border-radius": "6px",
              "font-size": ".875rem",
              "font-weight": 500,
              cursor: busy() ? "wait" : "pointer",
            }}
          >
            {busy() ? "Connexion..." : "Se connecter"}
          </button>
          <Show when={error()}>
            <p style={{ color: "#f87171", "font-size": ".8rem", "margin-top": ".75rem", "text-align": "center" }}>
              {error()}
            </p>
          </Show>
        </form>
      </div>
    </div>
  );
}
